// Small pieces shared by the record control, the recording strip, the capture
// view and the live panel (BUILD 1 WP-4): the clock and the level meter. There
// is no spoken-language choice: engines detect it. Owner: WP-4.

/** 0:07, 12:34, 1:02:03 */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = String(total % 60).padStart(2, '0');
  return hours
    ? `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`
    : `${minutes}:${seconds}`;
}

/** Five bars answering the one question anyone has while recording: is it hearing me. */
export function LevelMeter({ level, label }: { level: number; label: string }) {
  const lit = Math.min(5, Math.round(Math.sqrt(Math.max(0, level)) * 10));
  return (
    <span
      className="ws-level-meter"
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={5}
      aria-valuenow={lit}
    >
      {[1, 2, 3, 4, 5].map((bar) => (
        <span key={bar} data-lit={bar <= lit || undefined} />
      ))}
    </span>
  );
}
